export const WQI_PARAMS = [
  {
    key: "dissolved_oxygen_mg_l_clean_avg",
    type: "DO",
    Si: 6.5,
    Wi: 0.358855,
  },
  {
    key: "ph_clean_avg",
    type: "PH",
    Si: 8.5,
    Wi: 0.274418,
  },
  {
    key: "bod_mg_l_clean_avg",
    type: "NORMAL",
    Si: 10,
    Wi: 0.233256,
  },
  {
    key: "cod_mg_l_clean_avg",
    type: "NORMAL",
    Si: 100,
    Wi: 0.023326,
  },
  {
    key: "ammonia_mg_l_clean_avg",
    type: "NORMAL",
    Si: 32.5,
    Wi: 0.071771,
  },
  {
    key: "chloride_mg_l_clean_avg",
    type: "NORMAL",
    Si: 155,
    Wi: 0.015049,
  },
  {
    key: "tss_mg_l_clean_avg",
    type: "NORMAL",
    Si: 100,
    Wi: 0.023326,
  },
];
